import React from 'react';
import { Box, Heading, TabItem, TabList, Tabs } from '@razorpay/blade/components';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import permissions from 'constants/permissions';
import * as loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import { routePaths } from 'components/Routes/data';
import { employeeDataTabs, getEmployeeDataTabItems } from './constants';
import { getEmployeeDataTabValue } from './utils';
import { GeneralTab } from './components/GeneralTab';
import { EmployeeFieldsTab } from './components/EmployeeFieldsTab';

const EmployeeDataSettings = () => {
  const history = useHistory();
  const location = useLocation();
  const userPermissions = useSelector(loggedInUserSelectors.permissions);
  const canEditGeneral = userPermissions.includes(permissions.EDIT_COMPANY_DETAILS);
  const canManageFields = userPermissions.includes(permissions.MANAGE_CUSTOM_FIELDS);
  const currentTab = getEmployeeDataTabValue(location.pathname);
  const firstVisibleRoute = canEditGeneral
    ? routePaths.settings.employeeData.general
    : routePaths.settings.employeeData.fields;

  const visibleTabs = getEmployeeDataTabItems().filter((tab) => {
    if (tab.value === employeeDataTabs.general) return canEditGeneral;
    return canManageFields;
  });

  return (
    <Box minHeight="100vh" backgroundColor="surface.background.gray.subtle">
      <Box paddingTop="spacing.5" paddingX="spacing.10" paddingBottom="spacing.9">
        <Heading size="xlarge">Employee Data</Heading>

        <Box marginTop="spacing.5">
          <Tabs
            value={currentTab}
            defaultValue={employeeDataTabs.general}
            onChange={(value) => {
              const targetTab = visibleTabs.find((tab) => tab.value === value);
              if (targetTab) history.push(targetTab.path);
            }}
          >
            <TabList>
              {visibleTabs.map((tab) => (
                <TabItem key={tab.value} value={tab.value}>
                  {tab.children}
                </TabItem>
              ))}
            </TabList>
          </Tabs>
        </Box>

        <Box marginTop="spacing.9">
          <Switch>
            <Route path={routePaths.settings.employeeData.root} exact>
              <Redirect to={firstVisibleRoute} />
            </Route>
            <Route path={routePaths.settings.employeeData.general} exact>
              {canEditGeneral ? <GeneralTab /> : <Redirect to={routePaths.settings.employeeData.fields} />}
            </Route>
            <Route path={routePaths.settings.employeeData.fields} exact>
              {canManageFields ? <EmployeeFieldsTab /> : <Redirect to={routePaths.settings.employeeData.general} />}
            </Route>
            <Route>
              <Redirect to={firstVisibleRoute} />
            </Route>
          </Switch>
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeDataSettings;
